(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('cpfCnpjAlfaMask', cpfCnpjAlfaMask);

    /**
     * Máscara e validação de CPF/CNPJ com suporte ao CNPJ alfanumérico (IN RFB 2229/2024).
     * CNPJ: 12 primeiras posições alfanuméricas (A-Z, 0-9) e 2 dígitos verificadores numéricos.
     * O modelo recebe o valor limpo (sem pontuação); a view exibe o valor mascarado.
     * Com cpf-cnpj-alfa-mask="cnpj", o campo aceita somente CNPJ (sem modo CPF).
     * Com cpf-cnpj-alfa-mask="cpf", o campo aceita somente CPF (sem modo CNPJ), apenas com dígitos.
     */
    function cpfCnpjAlfaMask() {
        var CNPJ_DV1_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        var CNPJ_DV2_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        var NON_DIGITS_REGEX = /[^0-9]/g;
        var NON_DIGITS_OR_MASK_REGEX = /[^0-9*]/g;
        var NON_ALPHANUMERIC_REGEX = /[^0-9A-Z]/g;
        var NON_ALPHANUMERIC_OR_MASK_REGEX = /[^0-9A-Z*]/g;

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
                var cnpjOnly = attrs.cpfCnpjAlfaMask === 'cnpj';
                var cpfOnly = attrs.cpfCnpjAlfaMask === 'cpf';

                function clean(value) {
                    var isObfuscated = attrs.showObfuscated ? !!scope.$eval(attrs.showObfuscated) : false;
                    var allowedCharsRegex;
                    if (cpfOnly) {
                        allowedCharsRegex = isObfuscated ? NON_DIGITS_OR_MASK_REGEX : NON_DIGITS_REGEX;
                    } else {
                        allowedCharsRegex = isObfuscated ? NON_ALPHANUMERIC_OR_MASK_REGEX : NON_ALPHANUMERIC_REGEX;
                    }
                    var v = (value || '').toString().toUpperCase().replace(allowedCharsRegex, '');
                    // posições 13 e 14 (dígitos verificadores) são sempre numéricas
                    return v.slice(0, 12) + v.slice(12).replace(/[^0-9]/g, '').slice(0, 2);
                }

                function isCnpjShape(v) {
                    if (cpfOnly) {
                        return false;
                    }
                    return cnpjOnly || v.length > 11 || /[A-Z]/.test(v);
                }

                function formatValue(v) {
                    var out;
                    if (!v) {
                        return '';
                    }
                    if (isCnpjShape(v)) {
                        out = v.slice(0, 2);
                        if (v.length > 2) out += '.' + v.slice(2, 5);
                        if (v.length > 5) out += '.' + v.slice(5, 8);
                        if (v.length > 8) out += '/' + v.slice(8, 12);
                        if (v.length > 12) out += '-' + v.slice(12, 14);
                    } else {
                        out = v.slice(0, 3);
                        if (v.length > 3) out += '.' + v.slice(3, 6);
                        if (v.length > 6) out += '.' + v.slice(6, 9);
                        if (v.length > 9) out += '-' + v.slice(9, 11);
                    }
                    return out;
                }

                function validateCpf(v) {
                    if (v.length !== 11 || /^(\d)\1{10}$/.test(v)) {
                        return false;
                    }
                    var sum = 0;
                    var i;
                    for (i = 0; i < 9; i++) {
                        sum += parseInt(v.charAt(i), 10) * (10 - i);
                    }
                    var dv1 = (sum * 10) % 11;
                    if (dv1 === 10) dv1 = 0;
                    if (dv1 !== parseInt(v.charAt(9), 10)) {
                        return false;
                    }
                    sum = 0;
                    for (i = 0; i < 10; i++) {
                        sum += parseInt(v.charAt(i), 10) * (11 - i);
                    }
                    var dv2 = (sum * 10) % 11;
                    if (dv2 === 10) dv2 = 0;
                    return dv2 === parseInt(v.charAt(10), 10);
                }

                // cada caractere vale (código ASCII - 48): '0'-'9' => 0-9, 'A'-'Z' => 17-42
                function calculateCnpjDv(chars, weights) {
                    var sum = 0;
                    for (var i = 0; i < chars.length; i++) {
                        sum += (chars.charCodeAt(i) - 48) * weights[i];
                    }
                    var mod = sum % 11;
                    return mod < 2 ? 0 : 11 - mod;
                }

                function validateCnpj(v) {
                    if (v.length !== 14 || /^0{14}$/.test(v)) {
                        return false;
                    }
                    if (calculateCnpjDv(v.slice(0, 12), CNPJ_DV1_WEIGHTS) !== parseInt(v.charAt(12), 10)) {
                        return false;
                    }
                    return calculateCnpjDv(v.slice(0, 13), CNPJ_DV2_WEIGHTS) === parseInt(v.charAt(13), 10);
                }

                ngModelCtrl.$formatters.push(function(value) {
                    return formatValue(clean(value));
                });

                ngModelCtrl.$parsers.push(function(value) {
                    var cleaned = clean(value);
                    var formatted = formatValue(cleaned);
                    if (value !== formatted) {
                        ngModelCtrl.$setViewValue(formatted);
                        ngModelCtrl.$render();
                    }
                    return cleaned;
                });

                ngModelCtrl.$validators.cpf = function(modelValue) {
                    var v = clean(modelValue);
                    if (!v) {
                        return true;
                    }
                    return isCnpjShape(v) || validateCpf(v);
                };

                ngModelCtrl.$validators.cnpj = function(modelValue) {
                    var v = clean(modelValue);
                    if (!v || !isCnpjShape(v)) {
                        return true;
                    }
                    return validateCnpj(v);
                };
            }
        };
    }
})();
